import { supabase, supabaseConfigured } from '../lib/supabase'

export const ACCESS_MESSAGES = {
  unauthorized: 'No tienes acceso a esta aplicación.',
  disabled: 'Tu cuenta se encuentra deshabilitada.',
  organizationDisabled: 'La organización se encuentra deshabilitada.',
  connection: 'No fue posible conectar con el servidor. Intenta nuevamente.',
  credentials: 'Correo o contraseña incorrectos.',
  configuration: 'Falta configurar la conexión con Supabase.',
}

export async function loadAccessProfile(user) {
  if (!user) return { cpUsuario: null, organizacion: null, rol: null }

  const { data: cpUsuario, error: userError } = await supabase
    .from('cp_usuarios')
    .select('id, organizacion_id, rol, activo, debe_cambiar_clave')
    .eq('auth_user_id', user.id)
    .maybeSingle()

  if (userError) throw new Error(ACCESS_MESSAGES.connection)
  if (!cpUsuario) throw new Error(ACCESS_MESSAGES.unauthorized)
  if (!cpUsuario.activo) throw new Error(ACCESS_MESSAGES.disabled)
  if (!['admin', 'directiva', 'socio'].includes(cpUsuario.rol)) {
    throw new Error(ACCESS_MESSAGES.unauthorized)
  }

  const { data: organizacion, error: organizationError } = await supabase
    .from('cp_organizaciones')
    .select('id, nombre, colegio, logo_url, activa')
    .eq('id', cpUsuario.organizacion_id)
    .maybeSingle()

  if (organizationError) throw new Error(ACCESS_MESSAGES.connection)
  if (!organizacion) throw new Error(ACCESS_MESSAGES.unauthorized)
  if (!organizacion.activa) throw new Error(ACCESS_MESSAGES.organizationDisabled)

  return { cpUsuario, organizacion, rol: cpUsuario.rol }
}

export async function signInWithEmail(email, password) {
  if (!supabaseConfigured) throw new Error(ACCESS_MESSAGES.configuration)

  const { data, error } = await supabase.auth.signInWithPassword({ email, password })
  if (error) {
    const connectionError = !error.status || error.status >= 500
    throw new Error(connectionError ? ACCESS_MESSAGES.connection : ACCESS_MESSAGES.credentials)
  }

  try {
    const profile = await loadAccessProfile(data.user)
    return { session: data.session, user: data.user, ...profile }
  } catch (profileError) {
    await supabase.auth.signOut()
    throw profileError
  }
}
